import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/apiClient';

const useForgetUser = () => {
  return useMutation({
    mutationKey: ['forgetUser'],
    mutationFn: () => apiClient.post('api/c2fo/user/forget'),
  });
};

export default useForgetUser;
